.time {
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  color: #f4f5f7;
  white-space: nowrap;
  user-select: none;
  letter-spacing: 0.01em;
  padding: 0 4px;
  opacity: 0.95;
}

.sep {
  opacity: 0.55;
  margin: 0 1px;
}
